import { useState } from 'react';
import { ListPageLayout } from '@practium/ui';
import { ParametersCard } from '@/features/parameters/components/Cards/ParametersCard/ParametersCard';
import { RegionsSidebar } from '@/features/parameters/components/Sidebar/RegionsSidebar/RegionsSidebar';
import { useParametersPage } from '@/features/parameters/hooks/useParametersPage';

export const ParametersPage = () => {
	const {
		regions,
		selectedRegion,
		stateReference,
		activeTab,
		selectedTexture,
		isLoadingRegions,
		isLoadingReference,
		setSelectedRegion,
		setActiveTab,
		setSelectedTexture,
		handleExportExcel,
		handleExportPdf,
		handleUpdate,
		handleCreateRegion,
		handleUpdateRegion,
	} = useParametersPage();

	const [isCreateOpen, setIsCreateOpen] = useState(false);

	return (
		<ListPageLayout
			sidebarWidth="28rem"
			sidebarW1500="22rem"
			sidebarW1300="19rem"
			sidebarW1200="17rem"
			sidebar={
				<RegionsSidebar
					regions={regions}
					selectedRegion={selectedRegion}
					isLoading={isLoadingRegions}
					isCreateModalOpen={isCreateOpen}
					onSelectRegion={setSelectedRegion}
					onCreateRegion={handleCreateRegion}
					onUpdateRegion={handleUpdateRegion}
					onCloseCreateModal={() => setIsCreateOpen(false)}
				/>
			}
		>
			<ParametersCard
				regionName={selectedRegion?.name ?? '—'}
				stateReference={stateReference}
				activeTab={activeTab}
				selectedTexture={selectedTexture}
				isLoading={isLoadingReference}
				onTabChange={setActiveTab}
				onTextureChange={setSelectedTexture}
				onExportExcel={handleExportExcel}
				onExportPdf={handleExportPdf}
				onUpdate={handleUpdate}
				onAddNew={() => setIsCreateOpen(true)}
			/>
		</ListPageLayout>
	);
};
